import React from 'react';
import { Container, Table, Row, Col, Button } from 'react-bootstrap';
import './App.css';

const episodes = ["S01e01.mkv","S01e02.mkv","S01e03.mkv","S01e04.mkv","S01e05.mkv","S01e06.mkv","S01e07.mkv","S01e08.mkv","S01e09.mkv","S01e10.mkv","S01e11.mkv","S01e12.mkv","S01e13.mkv","S01e14.mkv","S01e15.mkv","S01e16.mkv","S01e17.mkv","S01e18.mkv","S01e19.mkv","S01e20.mkv","S01e21.mkv","S01e22.mkv","S01e23.mkv","S02e01.mkv","S02e02.mkv","S02e03.mkv","S02e04.mkv","S02e05.mkv","S02e06.mkv","S02e07.mkv","S02e08.mkv","S02e09.mkv","S02e10.mkv","S02e11.mkv","S02e12.mkv","S02e13.mkv","S02e14.mkv","S02e15.mkv","S02e16.mkv","S02e17.mkv","S02e18.mkv","S02e19.mkv","S02e20.mkv","S02e21.mkv","S02e22.mkv","S02e23.mkv","S03e01.mkv","S03e02.mkv","S03e03.mkv","S03e04.mkv","S03e05.mkv","S03e06.mkv","S03e07.mkv","S03e08.mkv","S03e09.mkv","S03e10.mkv","S03e11.mkv","S03e12.mkv","S03e13.mkv","S03e14.mkv","S03e15.mkv","S03e16.mkv","S03e17.mkv","S03e18.mkv","S03e19.mkv","S03e20.mkv","S03e21.mkv","S03e22.mkv","S03e23.mkv","S03e24.mkv","S04e01.mkv","S04e02.mkv","S04e03.mkv","S04e04.mkv","S04e05.mkv","S04e06.mkv","S04e07.mkv","S04e08.mkv","S04e09.mkv","S04e10.mkv","S04e11.mkv","S04e12.mkv","S04e13.mkv","S04e14.mkv","S04e15.mkv","S04e16.mkv","S04e17.mkv","S04e18.mkv","S04e19.mkv","S04e20.mkv","S04e21.mkv","S04e22.mkv","S04e23.mkv","S04e24.mkv","S05e01.mkv","S05e02.mkv","S05e03.mkv","S05e04.mkv","S05e05.mkv","S05e06.mkv","S05e07.mkv","S05e08.mkv","S05e09.mkv","S05e10.mkv","S05e11.mkv","S05e12.mkv","S05e13.mkv","S05e14.mkv","S05e15.mkv","S05e16.mkv","S05e17.mkv","S05e18.mkv","S05e19.mkv","S05e20.mkv","S05e21.mkv","S05e22.mkv","S06e01.mkv","S06e02.mkv","S06e03.mkv","S06e04.mkv","S06e05.mkv","S06e06.mkv","S06e07.mkv","S06e08.mkv","S06e09.mkv","S06e10.mkv","S06e11.mkv","S06e12.mkv","S06e13.mkv","S06e14.mkv","S06e15.mkv","S06e16.mkv","S06e17.mkv","S06e18.mkv","S06e19.mkv","S06e20.mkv","S06e21.mkv","S06e22.mkv","S07e01.mkv","S07e02.mkv","S07e03.mkv","S07e04.mkv","S07e05.mkv","S07e06.mkv","S07e07.mkv","S07e08.mkv","S07e09.mkv","S07e10.mkv","S07e11.mkv","S07e12.mkv","S07e13.mkv"];

function App(props) {
    return (
        <Container className="p-3">
            <h1 className="text-center mb-3 mt-3">Mentalist Xavier</h1>
            <Row className="mb-3">
                <Col>
					<Table striped bordered hover>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Lien</th>
								<th>VLC</th>
							</tr>
						</thead>
						<tbody>
						{episodes.map(e => (
							<tr>
								<td>{e
									.replace('S0', 'Saison ')
									.replace('e0', ', épisode ')
									.replace('e1', ', épisode 1')
									.replace('e2', ', épisode 2')
									.replace('e3', ', épisode 3')
									.replace('.mkv', '')
								}</td>
								<td>
									<a href={'https://mentalist.samf.me/' + e}>{e}</a>
								</td>
								<td>
									<Button size="sm" onClick={() => window.location.assign('vlc://https://mentalist.samf.me/' + e)}>VLC</Button>
								</td>
							</tr>
						))}
						</tbody>
					</Table>
                </Col>
            </Row>
        </Container>
    )
}

export default App;
